import React, { useState, useEffect } from 'react';
import {
    required,
    SaveButton,
    TextInput,
    useCreate,
    useNotify,
    FormWithRedirect
} from 'react-admin';
import IconAccountTree from '@mui/icons-material/AccountTree';
import IconCancel from '@mui/icons-material/Cancel';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import {JSONTree} from 'react-json-tree'
import { Button, Box, Typography } from '@mui/material';

import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CheckIcon from '@mui/icons-material/Check';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import ImageIcon from '@mui/icons-material/Image';
import FolderIcon from '@mui/icons-material/Folder';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';

// const useStyles = makeStyles({
//     root: {
//         height: 340,
//         flexGrow: 1,
//         maxWidth: 400,
//     },

//     child: {
//         expanded: true
//     },

//     dialogPaper: {
//         minHeight: '300px',
//     },
// });


const NodeTreeButton = (props) => {
    const [showDialog, setShowDialog] = useState(false);
    const [json, setJson] = useState({});
    const [udid, setUdid] = useState(null);
    const [name, setName] = useState('');
    const [create, { loading }] = useCreate('project');
    const notify = useNotify();
    const [expanded, setExpanded] = useState([]);

    const aNodeRecur = (sketch_json, result, depth, selectableJsonDepth) => {
        if (sketch_json) {
            result.push(sketch_json.do_objectID)
            for (let i = 0; sketch_json.layers && i < sketch_json.layers.length; i++) {
                aNodeRecur(sketch_json.layers[i], result, depth + 1)
            }
        }
    }

    useEffect(() => {
        if(props.json)
            setJson(props.json)
        else
            setJson({})
        let a = []
        if (props.selectableJsonDepth)
            aNodeRecur(props.json, a, 0, props.selectableJsonDepth)
        else
            aNodeRecur(props.json, a, 0, 10000)
        setExpanded(a)
    }, [props.json])

    const handleClick = () => {
        
        setShowDialog(true);
    };

    const handleCloseClick = () => {
        setShowDialog(false);
    };

    const handleLabelClick = (udid, name) => {
        setUdid(udid)
        setName(name)
    };

    const getTreeNode = (j, depth, selectableJsonDepth) => (
        <TreeItem
            key={j.do_objectID}
            sx={{
                expanded: true
            }}
            nodeId={j && j.do_objectID}
            label={<Box style={{
                display: 'flex',
                alignItems: 'center'
            }}>
                {j && j._class == 'text' && <TextFieldsIcon />}
                {j && j._class == 'bitmap' && <ImageIcon />}
                {j && j._class == 'group' && <FolderIcon />}
                {j && j._class == 'rectangle' && <AspectRatioIcon />}

                {j && j._class != 'text' && j._class != 'bitmap' && j._class != 'group' && j._class != 'rectangle'
                    && `[${j._class}]`}
                &nbsp;
                <Typography variant="subtitle1" >
                    {j && j.name}
                </Typography>
                <Typography variant="subtitle2" >
                    
                </Typography>
            </Box>}

            onClick={e => { handleLabelClick(j && j.do_objectID, j && j.name) }}
        >
            {j && j.layers && depth < selectableJsonDepth && j.layers.map(m =>
                getTreeNode(m, depth + 1, selectableJsonDepth)
            )}
        </TreeItem>
    )
    const handleSelect = () => {
        props.onSelected(udid, name)
        setShowDialog(false);
    }

    return (
        <>
            <Button onClick={handleClick} startIcon={<IconAccountTree />}>
                
            </Button>
            <Dialog
                PaperProps={{
                    sx: {
                        width: "90%",
                        maxHeight: 500
                    },
                    md: {
                        width: "60%",
                        maxHeight: 500
                    }
                }}
                fullWidth
                maxWidth='lg'
                open={showDialog}
                onClose={handleCloseClick}
                aria-label="Node Tree"
                scroll="paper"
            >
                <DialogTitle>Sketch Node Tree</DialogTitle>

                <DialogContent>
                    <TreeView
                        sx={{minHeight: '300px'}}
                        defaultCollapseIcon={<ExpandMoreIcon />}
                        defaultExpandIcon={<ChevronRightIcon />}
                        defaultExpanded={expanded}
                    >
                        {getTreeNode(json, 0, props.selectableJsonDepth ? props.selectableJsonDepth : 10000)}
                    </TreeView>
                </DialogContent>
                <DialogActions>
                    <Button
                        label="ra.action.cancel"
                        onClick={handleSelect}
                        disabled={loading}
                        startIcon={<CheckIcon />}
                    >
                        Select
                    </Button>
                    <Button
                        label="ra.action.cancel"
                        onClick={handleCloseClick}
                        disabled={loading}
                        startIcon={<IconCancel />}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default NodeTreeButton;
